import { render, staticRenderFns } from "./_bulk_tag_products_modal.vue?vue&type=template&id=4beb4c6a&scoped=true&"
import script from "./_bulk_tag_products_modal.vue?vue&type=script&lang=js&"
export * from "./_bulk_tag_products_modal.vue?vue&type=script&lang=js&"
import style0 from "./_bulk_tag_products_modal.vue?vue&type=style&index=0&id=4beb4c6a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb4c6a",
  null
  
)

export default component.exports